<template>
<div class="modal_wrapper">
  <div class='container'>
    <div class='modal_container_settingPost'>
      <div class="modal_header">
        <div class="set_post_title">
          {{confirm}}
        </div>
      </div>
      <div class="postList">
        <div class="scroll">
          <div class="accordion">
            <ul class='postList_ul'>
              <li class="postList_li" v-for="loginUser in dispItems" :key="loginUser.postId">
                <div  v-for="item in loginUser.loginUserPost" :key="item.postId">
                  <div class='postList_div'>
                    <p class="accordion__toggle_parent">
                      <span v-show="item.childPost != null && isOpen.indexOf(item.postId) >= 0">
                        <img class='postList_nav_icon' :src='openIcon' @click="handleToggle(item.postId)">
                      </span>
                      <span v-show="item.childPost != null && isOpen.indexOf(item.postId) < 0">
                        <img class='postList_nav_icon' :src='closeIcon' @click="handleToggle(item.postId)">
                      </span>
                      <span v-show="item.childPost == null">
                        <img class='postList_nav_icon' :src='blackCircleIcon'>
                      </span>
                      <input type="checkbox" @click="setActive" :id="item.postId" :checked="selItems.indexOf(item.postId) >= 0">
                      <span :id="item.postId" v-text="item.postName"/>
                    </p>
                  </div>
                  <ul class='postListChild_ul' v-show="isOpen.indexOf(item.postId) >= 0">
                    <li class="postList_li" v-for="childDispLoginuser in item.childPost" :key="childDispLoginuser.postId">
                      <div class='postList_div'>
                        <p class="accordion__toggle">
                          <span v-show="childDispLoginuser.grandchildPost != null && isOpen.indexOf(childDispLoginuser.postId) >= 0">
                            <img class='postList_nav_icon' :src='openIcon' @click="handleToggle(childDispLoginuser.postId)">
                          </span>
                          <span v-show="childDispLoginuser.grandchildPost != null && isOpen.indexOf(childDispLoginuser.postId) < 0">
                            <img class='postList_nav_icon' :src='closeIcon' @click="handleToggle(childDispLoginuser.postId)">
                          </span>
                          <span v-show="childDispLoginuser.grandchildPost == null">
                            <img class='postList_nav_icon' :src='blackCircleIcon'>
                          </span>
                          <input type="checkbox" @click="setActive" :id="childDispLoginuser.postId" :checked="selItems.indexOf(childDispLoginuser.postId) >= 0">
                          <span :id="childDispLoginuser.postId" v-text="childDispLoginuser.postName"/>
                        </p>
                      </div>
                      <ul class='postListChild_ul' v-show="isOpen.indexOf(childDispLoginuser.postId) >= 0">
                        <li class="postList_li" v-for="grandchildDispLoginuser in childDispLoginuser.grandchildPost" :key="grandchildDispLoginuser.postId">
                          <div class='postList_div'>
                            <p class="accordion__toggle">
                              <img class='postList_nav_icon' :src='blackCircleIcon'>
                                <input type="checkbox" @click="setActive" :id="grandchildDispLoginuser.postId" :checked="selItems.indexOf(grandchildDispLoginuser.postId) >= 0">
                                <span :id="grandchildDispLoginuser.postId" v-text="grandchildDispLoginuser.postName"/>
                            </p>
                          </div>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
        <div class="modal_buttons">
          <input type=button :value='cancelButton' class="cancel_button" @click="$emit('close')">
          <input type=button :value='okButton' class="finish_button" @click="changePost">
        </div>
    </div>
  </div>
    <div class="complete_modal_window" v-if='showFailureModal'>
      <completeModalWindow :question='failureWord' @close="stayClose">
      </completeModalWindow>
    </div>
</div>
</template>

<script>
import completeModalWindow from './finishModalWindow.vue'
export default {
  props: ['dispItems', 'selItems'],
  data () {
    return {
      confirm: '所属の設定',
      cancelButton: 'キャンセル',
      okButton: '変更',
      isOpen: [],
      selectedPostId: [],
      setActivePostList: [],
      windowHeight: '',
      openIcon: require('../../img/arrowOpen.png'),
      closeIcon: require('../../img/arrowClose.png'),
      blackCircleIcon: require('../../img/blackCircle.png'),
      inputValue: '',
      failureWord: '',
      showloadingModal: false,
      showFalseModal: false,
      showFailureModal: false
    }
  },
  computed: {
    errorMsg () {
      return this.$store.state.error.errorMsg
    }
  },
  components: {
    completeModalWindow
  },
  async created () {
    this.selectedPostId = this.selItems
  },
  methods: {
    close (e) {
      this.showFalseModal = false
    },
    stayClose (e) {
      this.showFailureModal = false
    },
    // メニューを開閉する2
    handleToggle (index) {
      if (this.isOpen.indexOf(index) >= 0) {
        this.isOpen = this.isOpen.filter(n => n !== index)
      } else {
        this.isOpen.push(index)
      }
    },
    handleResize () {
      // ウィンドウサイズ変更時にリアルタイムでウィンドウサイズの値を更新
      this.updateWindowHeight()
    },
    updateWindowHeight () {
      this.windowHeight = window.innerHeight
    },
    changePost (e) {
      if (this.selectedPostId.length === 0) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_440001
        let eventType = 3
        let reason = 'MSGCRC0045 '
        this.failureWord = this.errorMsg.MSGCRC0045.name + this.errorMsg.MSGCRC0045.value + 'エラーコード：{' + eventNumber + '}'
        this.$store.dispatch('masters/writeLog', {eventNumber, eventType, reason})
        this.showFailureModal = true
      } else if (this.selectedPostId.length > 5) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_440001
        let eventType = 3
        let reason = 'MSGCRC0184 '
        this.failureWord = this.errorMsg.MSGCRC0184.name + this.errorMsg.MSGCRC0184.value + 'エラーコード：{' + eventNumber + '}'
        this.$store.dispatch('masters/writeLog', {eventNumber, eventType, reason})
        this.showFailureModal = true
      } else {
        let selectedPostId = this.selectedPostId
        this.$emit('changePost', selectedPostId)
      }
    },
    async setActive (e) {
      if (this.selectedPostId.indexOf(e.currentTarget.id) < 0) {
        this.selectedPostId.push(e.currentTarget.id)
      } else {
        let index = this.selectedPostId.indexOf(e.currentTarget.id)
        this.selectedPostId.splice(index, 1)
      }
    }
  }
}

</script>
<style scoped>
.modal_wrapper {
  background-color: rgba(0, 0, 0, .5);
}
.container {
  display: table-cell;
  vertical-align: middle;
}
.modal_container_settingPost{
  width: 500px;
  height: 500px;
  position: relative;
  margin: 0 auto;
  padding: 0;
  background-color: #fff;
  border-radius: 5px;
}
.set_post_title {
  color: #fff;
  padding: 10px 10px 5px 10px;
}
.postList {
  width: 400px;
  height: 50%;
  margin: 70px;
  background-color: #fff
}
.postList_ul {
  margin: 0;
  padding: 0;
}
.postList_li::marker {
  font-size: 0px;
}
.accordion {
  color: #444;
  top: 67px;
  left: 0;
}
.scroll {
  overflow-y: scroll;
  height: 250px;
}
.accordion__toggle {
  line-height: 2.818;
  text-align: left;
  display: block;
  width: 100%;
  position: relative;
  cursor: default;
  margin: 0;
  display: inline-block;
}
.accordion__toggle_parent {
  line-height: 2.818;
  text-align: left;
  display: block;
  width: 100%;
  position: relative;
  cursor: default;
  margin: 0;
  display: inline-block;
}
.postList_div {
  vertical-align: middle;
}
.postList_nav_icon {
  height: 12px;
  width: 14px;
  vertical-align: middle;
  padding-right: 5px;
  padding-left: 7px;
}
.postListChild_ul {
  margin: 0;
  padding-bottom: 5px;
  list-style: none;
}
</style>



// WEBPACK FOOTER //
// src/components/modalWindow/settingPostModalWindow.vue